import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';

const StyledLink = styled.a`
  position: relative;
  display: block;
  color: ${ds.brand('text')};
  font-size: ${ds.fontSize('s')};
  font-family: ${ds.get('type.fontFamily.text')};
  font-weight: ${props => ds.get(`type.fontWeight.${props.bold ? 'bold' : 'regular'}`)};
  text-decoration:none;
  padding: ${ds.get('metrics.xs')} 0 ${ds.get('metrics.xs')} 0;
    
  ${media.desktop`
      padding: calc(${ds.get('metrics.xs')} / 2) calc(${ds.get('metrics.xs')} * 2);
  `}
`;

export default StyledLink;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/MainNavigation/StyledExternalLink.jsx